export declare const ToProgress: any;
export default ToProgress;
export * from './src/progress';
